<!-- Toolbar -->
<mat-toolbar class="path-toolbar" background="white" style="height: 25px;">
  <mat-icon *ngIf="canNavigateUp" class="pointer path-back" (click)="navigateUp()">arrow_back</mat-icon>
  <span *ngIf="canNavigateUp" class="pointer path-text" [title]="path || ''" (click)="navigateUp()">
    {{ path || '' }}
  </span>
</mat-toolbar>

<mat-toolbar *ngIf="showSearch" background="white">
  <mat-form-field style="width:100%" appearance="fill">
    <input matInput type="text" placeholder="file / folder / command..." [(ngModel)]="filterArgs"
      (keyup.enter)="onEnter($event)" (keyup)="onKey($event)" />
  </mat-form-field>
</mat-toolbar>

<div class="file-grid-scroll">

  <mat-grid-list [cols]="COLS" rowHeight="100px">
    <mat-grid-tile *ngFor="let element of sortedFileElements | filenameFilter:filterArgs:fileType">



      <div *ngIf="element.isFolder; else fileTile" class="tile folder-tile"
        (dragenter)="onFolderDragEnter($event, element)" (click)="onTileClick(element)"
        (contextmenu)="onTileContextMenu($event, element, menuTrigger)" (dragover)="onFolderDragOver($event, element)"
        (dragleave)="onFolderDragLeave($event, element)" (drop)="onFolderDrop($event, element)"
        [class.folder-hover]="hoveredFolderId === element.id">

        <div class="tile-inner">
          <mat-icon class="file-or-folder-icon" [class.folder-icon-hover]="hoveredFolderId === element.id">
            {{ folderIcon(element) }}
          </mat-icon>

          <div class="tile-label" [title]="element.name">{{ displayName(element) }}</div>
        </div>

        <!-- ✅ DROP OVERLAY -->
        <div class="drop-overlay" *ngIf="hoveredFolderId === element.id">
          Move file here
        </div>
      </div>
      <!-- FILE -->
      <ng-template #fileTile>
        <div class="tile">
          <div class="tile-inner" draggable="true" (click)="onTileClick(element)"
            (contextmenu)="onTileContextMenu($event, element, menuTrigger)"
            (dragstart)="onFileDragStart($event, element)" (dragend)="onFileDragEnd($event)">
            <!-- FILE ICONS -->
            <!-- .baja — an RNA therapeutic design. Drawn rather than taken from the
                 Material set, which has no RNA glyph: a strand with an oligo duplexed to
                 it, over the prescription R. -->
            <!-- .design — an LOH design strategy: two strands, one allele marked, and a target. -->
            <svg *ngIf="element.name.endsWith('.design')" class="file-type-icon" viewBox="0 0 32 32" role="img" aria-label="LOH design strategy">
              <g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                <path d="M4 9 H22"/><path d="M4 16 H22"/>
              </g>
              <circle cx="13" cy="9" r="2.4" fill="currentColor"/>
              <circle cx="13" cy="16" r="2.4" fill="none" stroke="currentColor" stroke-width="1.3"/>
              <g fill="none" stroke="currentColor" stroke-width="1.6">
                <circle cx="24" cy="24" r="5"/><circle cx="24" cy="24" r="1.6" fill="currentColor"/>
                <path d="M24 17 V19.5 M24 28.5 V31 M17 24 H19.5 M28.5 24 H31"/>
              </g>
            </svg>
            <!-- .mutmax — a differential mutational matrix: a grid of cells, two columns marked
                 for the two samples being compared. -->
            <svg *ngIf="element.name.endsWith('.mutmax')" class="file-type-icon" viewBox="0 0 32 32" role="img" aria-label="Mutational matrix">
              <g fill="none" stroke="currentColor" stroke-width="1.4">
                <rect x="4" y="6" width="24" height="21" rx="2"/>
                <path d="M12 6 V27 M20 6 V27 M4 13 H28 M4 20 H28"/>
              </g>
              <rect x="4.9" y="13.9" width="6.2" height="5.2" fill="currentColor" opacity="0.85"/>
              <rect x="20.9" y="6.9" width="6.2" height="5.2" fill="currentColor" opacity="0.85"/>
              <rect x="12.9" y="20.9" width="6.2" height="5.2" fill="currentColor" opacity="0.5"/>
            </svg>
            <svg *ngIf="element.name.endsWith('.baja')" class="file-type-icon" viewBox="0 0 32 32"
              role="img" aria-label="GeneTx design">
              <g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                <path d="M3 8 C7 5, 11 11, 15 8 C19 5, 23 11, 29 8"/>
              </g>
              <g stroke="currentColor" stroke-width="1.3">
                <circle cx="6" cy="15" r="2" fill="currentColor"/>
                <circle cx="12" cy="15" r="2" fill="none"/>
                <circle cx="18" cy="15" r="2" fill="none"/>
                <circle cx="24" cy="15" r="2" fill="currentColor"/>
              </g>
              <g fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <path d="M7 29 V21 h4 a2.6 2.6 0 0 1 0 5 H7"/>
                <path d="M11 26 l4 3"/>
              </g>
            </svg>

            <!-- .genome (and the legacy .karyotype / .karyotype.json) — banded ideograms at
                 ascending heights, the same picture the chromosome view draws. -->
            <svg *ngIf="element.name.endsWith('.genome') || element.name.endsWith('.karyotype') || element.name.endsWith('.karyotype.json')"
              class="file-type-icon" viewBox="0 0 32 32" role="img" aria-label="Genome">
              <g stroke="currentColor" stroke-width="1.4" fill="none">
                <rect x="4"  y="10" width="6" height="14" rx="3"/>
                <rect x="13" y="7"  width="6" height="19" rx="3"/>
                <rect x="22" y="4"  width="6" height="24" rx="3"/>
              </g>
              <g fill="currentColor">
                <rect x="4"  y="14" width="6" height="1.7"/>
                <rect x="4"  y="19" width="6" height="1.3"/>
                <rect x="13" y="12" width="6" height="1.7"/>
                <rect x="13" y="19" width="6" height="1.3"/>
                <rect x="22" y="9"  width="6" height="1.7"/>
                <rect x="22" y="16" width="6" height="1.3"/>
                <rect x="22" y="22" width="6" height="1.3"/>
              </g>
            </svg>

            <mat-icon *ngIf="element.name.endsWith('.screen')" color="accent"
              class="file-or-folder-icon">view_list</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.ljp')" color="info"
              class="file-or-folder-icon">data_table</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.ljt')" color="info"
              class="file-or-folder-icon">view_module</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.timeline')" color="accent"
              class="file-or-folder-icon">calendar_today</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.pdf')" color="warn"
              class="file-or-folder-icon">picture_as_pdf</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.ljl')" color="primary"
              class="file-or-folder-icon">description</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.ljlpx')" color="accent"
              class="file-or-folder-icon">table_chart</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.layout')" color="accent"
              class="file-or-folder-icon">dashboard</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.tsv')" color="primary"
              class="file-or-folder-icon">data_object</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.csv')" color="primary"
              class="file-or-folder-icon">data_object</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.bigwig')" color="primary"
              class="file-or-folder-icon">storage</mat-icon>
            <mat-icon *ngIf="element.name.endsWith('.bam')" color="primary"
              class="file-or-folder-icon">storage</mat-icon>
            <mat-icon *ngIf="isUniconed(element)" class="file-or-folder-icon file-generic-icon">
              insert_drive_file</mat-icon>

            <!-- The extension is dropped only where the icon above identifies the type. -->
            <div class="tile-label" [title]="element.name">{{ displayName(element) }}</div>
          </div>
        </div>
      </ng-template>



      <span [matMenuTriggerFor]="rootMenu" [matMenuTriggerData]="{ element: element }" #menuTrigger="matMenuTrigger"
        class="menu-anchor"></span>


    </mat-grid-tile>
  </mat-grid-list>
</div>

<!-- Context Menu -->
<mat-menu #rootMenu="matMenu">
  <ng-template let-element="element">
    <button mat-menu-item (click)="openFile(element)">
      <mat-icon>open_in_new</mat-icon>
      <span>Open</span>
    </button>
    <button mat-menu-item (click)="openRenameDialog(element)">
      <mat-icon>edit</mat-icon>
      <span>Rename</span>
    </button>
    <button mat-menu-item (click)="deleteElement(element)">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>
  </ng-template>
</mat-menu>